/**
 * @generated SignedSource<<c09a87c1de7f21c2d4ac4be3a1e7f9eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutSteps_preCheckoutTransaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryStep_preCheckoutTransaction" | "CheckoutReviewStep_preCheckoutTransaction">;
  readonly " $fragmentType": "CheckoutSteps_preCheckoutTransaction";
};
export type CheckoutSteps_preCheckoutTransaction$key = {
  readonly " $data"?: CheckoutSteps_preCheckoutTransaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutSteps_preCheckoutTransaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutSteps_preCheckoutTransaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryStep_preCheckoutTransaction"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStep_preCheckoutTransaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "bb9c4b8a5a8ced232a042d66e22d06dc";

export default node;
